import RightMenu from './fun-menu'

import {
  openRightMenu,
  closeRightMenu,
} from './function.js'

export default (Vue, name) => {
  Vue.component(RightMenu.name, RightMenu)
  Vue.prototype[name] = {
    open: openRightMenu,
    close: closeRightMenu,
  }
  // Vue.prototype[name] = openRightMenu
}
